import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
//@ts-expect-error Could not find declaration file for module
import upworkLogoUrl from 'bender-url!../../../../images/logo-upwork.png';
import { useCallback } from 'react';
import UIImage from 'UIComponents/image/UIImage';
import UIFlex from 'UIComponents/layout/UIFlex';
import { useTrack } from '../../tracks';
import UsageTracker from '../../../utils/UsageTracker';
import { useSendToUpwork } from '../upworkQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SendToUpwork = ({
  trackId,
  language
}) => {
  const {
    track
  } = useTrack(trackId, language);
  const {
    sendToUpwork,
    sendToUpworkLoading,
    sendToUpworkError,
    sentToUpworkAlready
  } = useSendToUpwork({
    trackId
  });
  const onAddToUpwork = useCallback(async () => {
    try {
      await sendToUpwork();
      UsageTracker.track('awardInteraction', {
        action: 'send-to-upwork',
        trackId: trackId.toString(),
        trackName: track && track.name
      });
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }, [sendToUpwork, track, trackId]);
  const stepTwoTranslation = sentToUpworkAlready ? 'learningCenter.upwork.addToUpworkStepTwoSent_jsx' : sendToUpworkError ? 'learningCenter.upwork.addToUpworkStepTwoError_jsx' : 'learningCenter.upwork.addToUpworkStepTwo_jsx';
  return /*#__PURE__*/_jsxs(UIFlex, {
    direction: "row",
    children: [/*#__PURE__*/_jsx(UIFlex, {
      justify: "center",
      style: {
        width: 195,
        flexGrow: 0
      },
      children: /*#__PURE__*/_jsx(UIImage, {
        src: upworkLogoUrl
      })
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.upwork.gotUpwork"
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "learningCenter.upwork.addToUpworkStepOne"
        })
      }), sendToUpworkLoading ? /*#__PURE__*/_jsx(UILoadingSpinner, {
        label: I18n.text('learningCenter.upwork.addToUpworkStepTwoSending'),
        showLabel: true,
        size: "xs",
        style: {
          margin: 0
        }
      }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          Link: UILink
        },
        message: stepTwoTranslation,
        options: {
          onClick: onAddToUpwork
        }
      })]
    })]
  });
};